import styled from 'styled-components';

const ScreenerButton = styled.div`
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 500;
  height: 54px;
  width: auto;
  background: linear-gradient(270deg,#ff863b -65.78%, #f66161 45.1%);
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  border: none;
  border-bottom: 4px solid #d13f3f;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 700;
  color: #FFFFFF;
  padding: 0.75em 1.75em;
  display: flex;
  align-items: center;
  justify-content: center;
  a, a:hover, a:visited, a:active {
    color: white;
  }
  svg {
    height: 60%;
    margin-right: 4px;
    margin-left: -4px;
    path {
      fill: white;
    }
  }
  &:hover {
    cursor: pointer;
  }
  @media (max-width: 45em) {
    left: 20px;
    right: 20px;
    width: calc(100vw - 40px);
  }

  transform: translateY(200%);
  &.slide-in {
    animation: slide-in 0.75s forwards;
  }
  @keyframes slide-in {
    100% {
      transform: translateY(0%);
    }
  }
`;

export default ScreenerButton;
